module.exports = __webpack_public_path__ + "img/btn1.99acbfd4.png";